import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { addBlog } from '../../utils/api';
import Swal from 'sweetalert2';
const AddBlog = ({onClose}) => {
  const [formData, setFormData] = useState({
    badges: '',
    image: '',
    title: '',
    desc: '',
    author: '',
  });

  const mutation = useMutation(addBlog);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const blogData = {
      badges: formData.badges.split(',').map((badge) => badge.trim()),
      image: formData.image,
      title: formData.title,
      desc: formData.desc,
      author: formData.author,
      liked: false,
      likeCount: 0,
    };

    try {
      await mutation.mutateAsync(blogData);
    } catch (error) {
      console.error('Failed to create blog:', error);
    }
  };

  useEffect(() => {
    if (mutation.isSuccess) {
      console.log('Blog created successfully');
      setFormData({
        badges: '',
        image: '',
        title: '',
        desc: '',
        author: '',
      }); // Reset form fields after successful submission

      // Show success alert using Swal.fire
      Swal.fire({
        icon: 'success',
        title: 'Blog Created',
        text: 'Your blog has been created successfully!',
        timer: 3000, // Duration the alert will be shown (in milliseconds)
        showConfirmButton: false, // Disable the "OK" button
      });

      onClose(); // Close the modal after showing the success alert
    } else if (mutation.isError) {
      console.error('Failed to create blog:', mutation.error);

      // Show error alert using Swal.fire
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to create blog. Please try again later.',
      });
    }
  }, [mutation.isSuccess, mutation.isError, mutation.error, onClose]);

  return (
    <div className="flex flex-col justify-center sm:py-12">
      <div className="relative sm:max-w-xl sm:mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-300 to-warning shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
        <div className="relative px-4 py-4 bg-white shadow-lg sm:rounded-3xl sm:p-20">
          <div className="max-w-md mx-auto">
            <div>
              <h1 className="text-2xl font-semibold pb-4">Create Blog</h1>
            </div>
            <div className="divide-y divide-gray-200">
              <form onSubmit={handleSubmit} className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                <div className="grid grid-cols-2 gap-4">
                  <div className="relative">
                    <input
                      autoComplete="on"
                      id="badges"
                      name="badges"
                      type="text"
                      className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                      placeholder="Badges (separate with commas)"
                      required
                      value={formData.badges}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="badges"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Badges 
                    </label>
                  </div>
                  <div className="relative">
                    <input
                      autoComplete="on"
                      id="image"
                      name="image"
                      type="text"
                      className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                      placeholder="Image URL"
                      required
                      value={formData.image}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="image"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Image URL
                    </label>
                  </div>
                  <div className="relative">
                    <input
                      autoComplete="on"
                      id="title"
                      name="title"
                      type="text"
                      className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                      placeholder="Title"
                      required
                      value={formData.title}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="title"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Title
                    </label>
                  </div>
                  <div className="relative">
                    <input
                      autoComplete="on"
                      id="author"
                      name="author"
                      type="text"
                      className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                      placeholder="Author"
                      required
                      value={formData.author}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="author"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Author
                    </label>
                  </div>
                </div>
                <div className="relative">
                  <textarea
                    id="desc"
                    name="desc"
                    className="peer placeholder-transparent h-20 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600 resize-none"
                    placeholder="Description"
                    required
                    value={formData.desc}
                    onChange={handleChange}
                  ></textarea>
                  <label
                    htmlFor="desc"
                    className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                  >
                    Description
                  </label>
                </div>
                <div className="relative">
                  <button
                    type="submit"
                    className="bg-warning text-white rounded-md px-2 py-1"
                  >
                    Create Blog
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;